<section [ngSwitch]="currentStep">
  <hfc-standalone-form-container
    *ngSwitchCase="0"
    [timeLineContent]="timeLineContent"
    [showButtons]="true"
    [showTimeLine]="true"
    [nextLabel]="'Save and Next'"
    [showCopyright]="true"
    [stepNumber]="0"
    [nextDisabled]="!passwordForm?.invitationSignUpFormGroup?.valid"
    (nextAction)="setPassword()"
  >
    <hfc-sign-up-password
      #passwordForm
      (complete)="getPassword($event)"
      [userData]="userInvited"
    ></hfc-sign-up-password>
  </hfc-standalone-form-container>

  <hfc-standalone-form-container
    *ngSwitchCase="1"
    [timeLineContent]="timeLineContent"
    [showButtons]="false"
    [showTimeLine]="true"
    [showCopyright]="true"
    [stepNumber]="1"
  >
    <hfc-sign-up-mobile-authorisation
      (complete)="setupTwoFactorAuthenticationCompleted($event)"
    ></hfc-sign-up-mobile-authorisation>
  </hfc-standalone-form-container>

  <hfc-standalone-form-container
    *ngSwitchCase="2"
    [timeLineContent]="timeLineContent"
    [showTimeLine]="!signUpStateService.termsAndConditionsAreDeclined$.value"
    [showButtons]="true"
    [nextLabel]="!signUpStateService.termsAndConditionsAreDeclined$.value ? 'Accept' : null"
    [backLabel]="!signUpStateService.termsAndConditionsAreDeclined$.value ? 'Decline' : 'Go back'"
    [showCopyright]="false"
    [stepNumber]="2"
    (nextAction)="acceptTermsAndConditions()"
    (backAction)="declineTermsAndConditions()"
  >
    <hfc-sign-up-terms-and-conditions
      [isDeclined]="signUpStateService.termsAndConditionsAreDeclined$.value"
    ></hfc-sign-up-terms-and-conditions>
  </hfc-standalone-form-container>

  <hfc-contact-preferences-standalone
    *ngSwitchCase="3"
    [isStandalone]="false"
    [timeLineContent]="timeLineContent"
    [clientId]="signUpStateService.userApplicantId$.value"
    (nextAction)="confirmCommsPreferences($event)"
  >
  </hfc-contact-preferences-standalone>
</section>
